import { render, staticRenderFns } from "./downIdCard.vue?vue&type=template&id=5db99cf1&scoped=true"
import script from "./downIdCard.vue?vue&type=script&lang=js"
export * from "./downIdCard.vue?vue&type=script&lang=js"
import style0 from "./downIdCard.vue?vue&type=style&index=0&id=5db99cf1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db99cf1",
  null
  
)

export default component.exports